module.exports = __webpack_public_path__ + "static/media/near_west_hill_small.72cb0bae.jpg";